import React, { FunctionComponent } from "react";

import { Card } from "@/components/Card";
import { IStyleInnerBorder, IStyleInnerPadding, IStylePadding } from "@/eworkitComponents";

interface IStyledContentProps extends IStylePadding, IStyleInnerPadding, IStyleInnerBorder {
  className?: string;
}

export const StyledContent: FunctionComponent<Partial<IStyledContentProps>> = ({
  children,
  className,
  ...restProps
}) => {
  return (
    <Card padding={["lg"]} innerPadding="lg" innerBorder {...restProps} className={className}>
      {children}
    </Card>
  );
};
